import { InputField } from '@advanza/input'
import { Button, LoadingDots, PreIcon } from '@advanza/ui'
import { changeSubscriptionTravelRange } from 'actions/subscriptions'
import SearchLocationInput from 'components/ui/SearchLocationInput'
import { useAppDispatch } from 'hooks/hooks'
import { useSubscriptionArea } from 'hooks/providerHooks'
import style from './ServiceAreaRadius.module.css'

interface Props {
    subscriptionId: string
}

const ServiceAreaRadius = ({ subscriptionId }: Props) => {
    const dispatch = useAppDispatch()
    const { postalCode, subscription, isSaving, setByRadius } = useSubscriptionArea(
        subscriptionId,
        false,
    )
    if (!postalCode || !subscription) {
        return <div></div>
    }
    return (
        <div className={style.root}>
            <div>
                <InputField
                    type="number"
                    inputStyle={{ maxWidth: 75 }}
                    after={'km'}
                    value={postalCode.distance}
                    onChange={({ target }) =>
                        dispatch(
                            changeSubscriptionTravelRange(subscription.subscription_id, {
                                ...postalCode,
                                distance: target.value,
                            }),
                        )
                    }
                />
            </div>
            <SearchLocationInput
                withIcon
                countryCode={subscription.country_code}
                value={postalCode.place_name}
                onChangeLocation={(location) => {
                    dispatch(changeSubscriptionTravelRange(subscriptionId, location))
                }}
            />
            <div>
                <Button name="text" disabled={isSaving} onClick={setByRadius}>
                    <PreIcon primColor icon="refresh">
                        Update
                    </PreIcon>{' '}
                    {isSaving && <LoadingDots />}
                </Button>
            </div>
        </div>
    )
}

export default ServiceAreaRadius
